import { AuthActionTypes, ILogOutUser, ISetLogOutUser, ISetShowLogOutPrompt } from './types/actions';
import { NavigateFunction } from 'react-router-dom';

export const setShowLogOutPrompt = (showLogOutPrompt: boolean): ISetShowLogOutPrompt => ({
  type: AuthActionTypes.SET_SHOW_LOG_OUT_PROMPT,
  payload: { showLogOutPrompt },
});

export const setLogOutUser = (logOutUser: boolean): ISetLogOutUser => ({
  type: AuthActionTypes.SET_LOG_OUT_USER,
  payload: { logOutUser },
});

export const logOutUser = (navigate: NavigateFunction, userActionedSignOut?: boolean): ILogOutUser => ({
  type: AuthActionTypes.LOG_OUT_USER,
  payload: { navigate, userActionedSignOut },
});
